/* Progressive enhancement: native details menus work without JavaScript. */
(() => {
  if (window.faNavigationBound) return;
  window.faNavigationBound = true;

  const closeMenus = (except) => {
    document.querySelectorAll('[data-fa-menu][open]').forEach((menu) => {
      if (menu !== except) menu.open = false;
    });
  };
  document.addEventListener('click', (event) => {
    if (event.target instanceof Element) closeMenus(event.target.closest('[data-fa-menu]'));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-fa-menu][open]').forEach((menu) => {
      const hadFocus = menu.contains(document.activeElement);
      menu.open = false;
      if (hadFocus) menu.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('focusin', (event) => {
    if (event.target instanceof Element) closeMenus(event.target.closest('[data-fa-menu]'));
  });

  // Keep sticky product controls below the real header, including after editor changes.
  let header = null;
  let observer = null;
  const measureHeader = () => {
    if (!header?.isConnected) return;
    const height = Math.ceil(header.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--fa-header-height', `${height}px`);
  };
  const bindHeader = () => {
    const next = document.querySelector('[data-fa-header]');
    if (next === header) {
      measureHeader();
      return;
    }
    observer?.disconnect();
    observer = null;
    header = next;
    if (!header) return;
    measureHeader();
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(measureHeader);
      observer.observe(header, { box: 'border-box' });
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindHeader, { once: true });
  } else {
    bindHeader();
  }
  window.addEventListener('resize', measureHeader, { passive: true });
  document.fonts?.ready.then(measureHeader);
  document.addEventListener('shopify:section:load', bindHeader);
  document.addEventListener('shopify:section:unload', (event) => {
    if (header && event.target instanceof Element && event.target.contains(header)) {
      observer?.disconnect();
      observer = null;
      header = null;
    }
  });
})();
